import RoleTypes from "../../constants/RoleTypes";

export const ValidateUserEntitlements = (faOptions, userRole, officeNumber, faNumber) => {
    let response = false;
    let splitFaOption = [];

    //split Fa into OfficeNum and FANum
    if (faOptions) {
        faOptions.forEach((v) => {
            const faSplit = v.id && v.id.split('-');
            if (faSplit.length === 2) {
                splitFaOption.push({ OfficeNum: faSplit[0], FANum: faSplit[1] });
            }
        });
    }

    const isValidOfficeFANumber = (fa) => (fa.FANum !== '000' && fa.FANum === faNumber && fa.OfficeNum === officeNumber);

    // Validate user entitlements based on role
    switch (userRole.toLowerCase()) {
        case RoleTypes.ROLE_FINANCIAL_ADVISOR:
        case RoleTypes.ROLE_CSA:
        case RoleTypes.ROLE_REGISTERED_CSA: {
            response = splitFaOption && splitFaOption.some(fa => isValidOfficeFANumber(fa));
            break;
        }
        case RoleTypes.ROLE_OPERATIONS:
        case RoleTypes.ROLE_PRODUCTION_SUPPORT:
        case RoleTypes.ROLE_ADMIN: {
            response = true;
            break;
        }
        case RoleTypes.ROLE_BRANCH_MANAGER:
        case RoleTypes.ROLE_PRODUCING_BRANCH_MANAGER: {
            response = splitFaOption && splitFaOption.some(fa => (isValidOfficeFANumber(fa)) || (fa.FANum === '000' && fa.OfficeNum === officeNumber));
            break;
        }
        default:
            response = false;
    }
    return response;
}



// WEBPACK FOOTER //
// ./src/components/Common/ValidateUserEntitlements.js